<template>
  <div>
    <custom-actions show-back>
      <el-form v-loading="loading" class="global-form" :model="formData" ref="form" label-width="120px">
        <div class="row-title">基本信息</div>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="bidTitle" label="标题">
              {{ formData.bidTitle }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="purchaser" label="采购方">
              {{ formData.purchaserName || '--' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item prop="specList" label="规格">
            <el-table :data="formData.specList">
              <!-- <el-table-column prop="" label="采购类型">
                <template v-slot="{ row }">
                  <span v-if="row.purchaseType === '1'">粮油</span>
                  <span v-if="row.purchaseType === '2'">物料</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="specName" label="规格"></el-table-column>
              <el-table-column prop="specXh" label="规格单位"></el-table-column>
              <el-table-column prop="deliveryPrice" label="暂定单价/结算单价"></el-table-column>
              <el-table-column prop="basisPrice" label="基差价格"></el-table-column>
              <el-table-column prop="purchaseQuantity" label="订单数量"></el-table-column>
            </el-table>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="bidStart" label="招标开始日期">
              {{ formData.bidStart || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="bidEnd" label="招标截至日期">
              {{ formData.bidEnd || '--' }}

            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="supplierListStr" label="供应商">
              {{ formData.supplierListStr || '--' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="bidEnd" label="状态">
              <el-tag v-if="formData.status == '1'">招标中</el-tag>
              <el-tag v-if="formData.status == '2'">评标中</el-tag>
              <el-tag type="success" v-if="formData.status == '3'">已中标</el-tag>
              <el-tag type="danger" v-if="formData.status == '4'">已废标</el-tag>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="invoiceReq" label="发票要求">
              {{ formData.invoiceReq || '--' }}

            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="deliveryReq" label="发货要求">
              {{ formData.deliveryReq || '--' }}

            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="paymentReq" label="账期要求">
              {{ formData.paymentReq || '--' }}

            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="qualityReq" label="质量要求">
              {{ formData.qualityReq || '--' }}

            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="remark" label="备注说明">
              {{ formData.remark || '--' }}

            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" :readonly="true"></file-upload>
            </el-form-item>
          </el-col>

        </el-row>
        <div class="row-title">供应商信息</div>
        <el-row>
          <el-col :span="24">
            <el-table size="mini" stripe border :data="formData.supplierList">
              <el-table-column show-overflow-tooltip min-width="100" label="供应商名称"
                prop="supplierName"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="120" label="报名状态" prop="regStatus">
                <template v-slot="{ row }">
                  <!-- 1待处理2已接受3已拒绝 -->
                  <el-tag type="warning" v-if="row.regStatus == '1'">待处理</el-tag>
                  <el-tag v-if="row.regStatus == '2'">已接受</el-tag>
                  <el-tag type="danger" v-if="row.regStatus == '3'">已拒绝</el-tag>
                </template>
              </el-table-column>
              <!-- 1未中标2已中标3已拒绝 -->
              <el-table-column show-overflow-tooltip min-width="140" label="中标状态" prop="bidStatus">
                <template v-slot="{ row }">
                  <el-tag type="warning" v-if="row.bidStatus == '1'">未中标</el-tag>
                  <el-tag v-if="row.bidStatus == '2'">已中标</el-tag>
                  <el-tag type="danger" v-if="row.bidStatus == '3'">已拒绝</el-tag>

                </template></el-table-column>
              <el-table-column show-overflow-tooltip min-width="140" label="报价(元)" prop="quote"></el-table-column>

              <el-table-column fixed="right" label="操作" width="130">
                <template v-slot="{ row }">
                  <el-button type="text"
                    v-if="row.regStatus == '2' && ['1', '2'].includes(formData.status) && row.bidStatus !== '2'"
                    @click="onBind(row)">中标</el-button>
                  <el-button type="text" @click="onDetail(row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
    <!-- 详情 -->
    <SupplierDialog v-if="showDialog" :showDlg.sync="showDialog" :relId="relId"></SupplierDialog>
    <!-- 中标 -->
    <BindSupplierDialog v-if="showDialog2" @successSave="loadData" :showDlg.sync="showDialog2" :dataInfo="dataInfo">
    </BindSupplierDialog>
  </div>
</template>

<script>
import SupplierDialog from '@/views/tenderDocument/SupplierDialog.vue'
import BindSupplierDialog from '@/views/tenderDocument/BindSupplierDialog.vue'
export default {
  name: 'TenderDocumentAdd',
  components: { SupplierDialog, BindSupplierDialog },
  data() {
    return {
      specList: [],
      supplierArr: [],
      formData: {
        purchaser: '',
        specList: [],
        purchaseQuantity: '',
        bidStart: '',
        bidEnd: '',
        invoiceReq: '',
        deliveryReq: '',
        paymentReq: '',
        qualityReq: '',
        remark: '',
        fileList: [],
        supplierList: [
          // {
          //   "supplierId": "1"
          // }
        ]
      },
      loading: false,
      showDialog: false,
      showDialog2: false,
      dataInfo: {},
      relId: ''

    }
  },
  computed: {
    bidId() {
      return this.$route.query.bidId
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasWinTheBid() { // 中标
      return this.buttonList.includes('winTheBid')
    }
  },
  created() {
    if (this.bidId) {
      this.loadData()
    }
  },
  methods: {
    // 中标
    onBind(item) {
      this.dataInfo = item
      this.showDialog2 = true
    },
    onDetail(item) {
      this.relId = item.relId
      this.showDialog = true
    },

    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tenderDocument.selectYcBidDocumentByBidId, {
        params: { bidId: this.bidId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []

        const arr = res.supplierList ? res.supplierList.map(item => item.supplierName) : ''

        res.supplierListStr = arr.join(',')
        this.formData = res || {}
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  margin-top: 14px;

  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-title {
  font-size: 14px;
  position: relative;
  padding-left: 14px;
  margin-bottom: 20px;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    height: 14px;
    width: 3px;
    background-color: #36f;
    border-radius: 2px;
    transform: translateY(-50%);
  }
}
</style>
